import {
  Modal,
  Form,
  Select,
  Col,
  message,
  Button,
  Row,
  Input,
  InputNumber,
} from 'antd';
import { useState } from 'react';
import { useEffect } from 'react';
import { ShowAllData } from '@/apiError/apiShow';
import { decryptData } from '@/components/reusable/crypto/Cipher';
import qz from 'qz-tray';
import returnPRN from '../barcode/returnPRN';
import { useTransactionContext } from '@/context/TransactionContext';
import {
  handleKeyDown,
  valueLimiterPurity,
} from '../validation/FormValidation';
import PreviewPRNSelectFormat from './PreviewPRNSelectFormat';
// import axios from 'axios';
import { hextorstr, KEYUTIL, KJUR, stob64 } from 'jsrsasign';
import { AntButton } from '@/common/ant-components/AntButton';

const PRNSelectPrintFormat = ({
  hideBarCode = false,
  visible,
  onClose,
  extraDetails,
  summaryData,
  formReport,
  barcodeValues,
  closeTransactionModal,
}) => {
  const [form] = Form.useForm();
  const [barcodePrintFormats, setBarcodePrintFormats] = useState([]);
  const [selectedPrinter, setSelectedPrinter] = useState(null);
  const [printers, setPrinters] = useState([]);
  const { barcodePrinterStatus } = useTransactionContext();
  const [isPreview, setIsPreview] = useState(false);

  const [disabledStates, setDisabledStates] = useState({});

  const userData = decryptData(localStorage.getItem('userData'));

  async function handlePrint(selectedBarcodeFormat, extraDetailsApi) {
    var config = qz.configs.create(selectedPrinter);
    let printPRN = [];

    if (formReport) {
      printPRN = [
        returnPRN(
          selectedBarcodeFormat?.prnCode,
          barcodeValues,
          extraDetailsApi?.[0]?.itemName,
          0,
          extraDetailsApi,
          summaryData,
          form,
        ),
      ];
    } else {
      printPRN = barcodeValues?.map((barcodeValue, index) => {
        return returnPRN(
          selectedBarcodeFormat?.prnCode,
          barcodeValue,
          extraDetails?.[index]?.itemName,
          index,
          extraDetails,
          summaryData,
          form,
        );
      });
    }

    try {
      await qz.print(config, printPRN);
      message.success('Printed successfully!', 2);
      onClose();
    } catch (error) {
      message.error(`Print Error: ${error}`, 2);
    }
  }

  const handleSelect = async (format, index) => {
    if (formReport) {
      try {
        const details = await ShowAllData.showDetails(
          `/transactions/item-details/print/?itemPrefix=${barcodeValues}`,
        );

        const modfiedDetailsData = details?.data?.detailsData?.map((item) => {
          const diamondData =
            item?.diamondData?.map((d) => ({
              ...d,
              rate: d?.salesRate,
              amount: d?.salesAmount,
            })) || [];

          const stoneData =
            item?.stoneData?.map((s) => ({
              ...s,
              rate: s?.salesRate,
              amount: s?.salesAmount,
            })) || [];

          return {
            ...item,
            stoneData,
            diamondData,
          };
        });
        handlePrint(format, [modfiedDetailsData?.[0]]);
      } catch (error) {
        console.error(error);
      }
    } else {
      handlePrint(format);
      // try {
      //   const details = await ShowAllData.showDetails(
      //     `/transactions/item-details/print/?itemPrefix=${barcodeValues}`,
      //   );
      // } catch (error) {
      // }
    }
    setDisabledStates((prev) => ({ ...prev, [index]: true }));
    setTimeout(() => {
      setDisabledStates((prev) => ({ ...prev, [index]: false }));
    }, 10000);
  };

  const setupQzSecurity = async () => {
    // const [certificateResponse, privateKeyResponse] = await Promise.all([
    //   axios.get('/qz-tray/cert.pem'),
    //   axios.get('/qz-tray/key.pem'),
    // ]);

    // qz.security.setCertificatePromise((resolve, reject) => {
    //   resolve(certificateResponse.data);
    // });

    // qz.security.setSignatureAlgorithm('SHA512');

    // qz.security.setSignaturePromise(function (toSign) {
    //   return function (resolve, reject) {
    //     try {
    //       var pk = KEYUTIL.getKey(privateKeyResponse.data);
    //       var sig = new KJUR.crypto.Signature({ alg: 'SHA512withRSA' });
    //       sig.init(pk);
    //       sig.updateString(toSign);
    //       var hex = sig.sign();
    //       resolve(stob64(hextorstr(hex)));
    //     } catch (err) {
    //       console.error(err);
    //       reject(err);
    //     }
    //   };
    // });

    // qz.security.setCertificatePromise((resolve) => resolve(demoCert));
    qz.security.setCertificatePromise((resolve) =>
      resolve(userData?.certificateKey),
    );
    qz.security.setSignatureAlgorithm('SHA512');

    qz.security.setSignaturePromise((toSign) => {
      return function (resolve, reject) {
        try {
          // const pk = KEYUTIL.getKey(demoPrivateKey);
          const pk = KEYUTIL.getKey(userData?.privateKey);
          const sig = new KJUR.crypto.Signature({ alg: 'SHA512withRSA' });
          sig.init(pk);
          sig.updateString(toSign);
          const hex = sig.sign();
          resolve(stob64(hextorstr(hex)));
        } catch (err) {
          reject(err);
        }
      };
    });
  };

  const connectQZ = async () => {
    if (!qz.websocket.isActive() && barcodePrinterStatus && !hideBarCode) {
      try {
        await qz.websocket.connect();
        // await getPrinters();
        // await getPrinters();
      } catch (error) {
        message.error(`QZ Tray Connection Error: ${error}`, 2);
      }
    }
  };

  const focusNode = (key) => {
    const inputInstance = form?.getFieldInstance(key);
    if (inputInstance) {
      inputInstance?.focus();
    }
  };

  const getPrinters = async () => {
    try {
      const availablePrinters = await qz.printers.find();
      const printerOptions = availablePrinters.map((printer) => ({
        label: printer,
        value: printer,
      }));
      setPrinters(printerOptions);
    } catch (error) {
      console.error(`Error fetching printers: ${error}`);
    }
  };

  useEffect(() => {
    async function fetchBarcodePrintFormats() {
      try {
        const printLayouts = await ShowAllData.showDetails(
          '/account/access/printer-layouts/',
        );
        setBarcodePrintFormats(
          printLayouts.data.filter(
            (item) => item.branchName === userData.branchName,
          ),
        );
      } catch (error) {
        console.error('Error fetching barcode print formats:', error);
      }
    }
    async function connectWithSecurity() {
      const IS_SECURE =
        userData?.privateKey?.length > 100 &&
        userData?.certificateKey?.length > 100;
      if (IS_SECURE) {
        await setupQzSecurity();
      }
      await connectQZ();
      if (IS_SECURE) {
        await getPrinters();
      }
    }
    connectWithSecurity();
    fetchBarcodePrintFormats();
  }, []);

  return (
    <>
      <Modal
        title="Select Print Format"
        open={visible}
        onCancel={onClose}
        width={false}
        footer={null}
        centered
      >
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '20px',
            marginBottom: '20px',
          }}
        >
          <Form form={form}>
            <Form.Item
              rules={[{ required: true, message: 'Please selected a printer' }]}
              name="printer"
              required
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <Select
                  placeholder="Select Printer"
                  onChange={(value) => setSelectedPrinter(value)}
                  options={printers}
                  style={{ width: '20rem' }}
                />
                <Button
                  type="primary"
                  onClick={getPrinters}
                  disabled={printers?.length > 0}
                >
                  Get Printers
                </Button>
              </div>
            </Form.Item>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <Form.Item name="generalRemarks" label="Remarks">
                <Input
                  onPressEnter={(e) => {
                    e.preventDefault();
                    focusNode('printQuantity');
                  }}
                  style={{ width: '100%' }}
                />
              </Form.Item>
              <Form.Item name="printQuantity" label="Quantity">
                <InputNumber
                  style={{ width: '60%' }}
                  max={99}
                  min={0}
                  controls={false}
                  onKeyDown={(e) => {
                    handleKeyDown(e);
                    valueLimiterPurity(e, 99);
                  }}
                  onPressEnter={(e) => {
                    e.preventDefault();
                    focusNode('previewBtn');
                  }}
                />
              </Form.Item>
            </div>
            <Form.Item name="previewBtn">
              <Button
                type="primary"
                style={{ marginBottom: '10px' }}
                onClick={() => setIsPreview(true)}
              >
                Preview Data
              </Button>
            </Form.Item>
            <Row gutter={[8, 8]}>
              {barcodePrintFormats.length > 0 ? (
                barcodePrintFormats?.map((format, index) => (
                  <Col key={index} span={6}>
                    <AntButton
                      key={index}
                      disabled={disabledStates[index] || false}
                      onClick={() => {
                        handleSelect(format, index);
                      }}
                    >
                      {format.heading}
                    </AntButton>
                  </Col>
                ))
              ) : (
                <p>Format Not found Please Configure from setting</p>
              )}
            </Row>
          </Form>
        </div>
      </Modal>
      <PreviewPRNSelectFormat
        extraDetails={extraDetails}
        summaryData={summaryData}
        formReport={formReport}
        barcodeValues={barcodeValues}
        barcodePrintFormats={barcodePrintFormats}
        isPreview={isPreview}
        setIsPreview={setIsPreview}
        form={form}
      />
    </>
  );
};

export default PRNSelectPrintFormat;
